import React, { ReactNode } from "react";

interface FormGroupProps {
  children: ReactNode;
  label?: string;
  required?: boolean;
  error?: string;
  className?: string;
  htmlFor?: string;
}

const FormGroup: React.FC<FormGroupProps> = ({
  children,
  label,
  required = false,
  error,
  className = "",
  htmlFor,
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label htmlFor={htmlFor} className="block mb-1 text-sm font-medium">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      {children}
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default FormGroup;
